
import { CampaignStatusType } from '../../enum/campaign-status.enum';
import { Status } from '../reusables';
import { CampaignStatusTranslationsService } from 'src/app/shared/translations';

/**
 * Blueprint for the campaign status object.
 */
export class CampaignStatus {
  public status: string;
  public statuses: Array<any> = [
    {
      value: CampaignStatusType.SUBSCRIBED,
      status: this.statusTranslationsService.i18nSubscribedStatus,
      select: this.statusTranslationsService.i18nSubscribedSelect,
      class: 'esf-tag--success'
    },
    {
      value: CampaignStatusType.UNSUBSCRIBED,
      status: this.statusTranslationsService.i18nUnsubscribedStatus,
      select: this.statusTranslationsService.i18nUnsubscribedSelect,
      class: 'esf-tag--alert'
    },
    {
      value: CampaignStatusType.BOUNCED,
      status: this.statusTranslationsService.i18nBouncedStatus,
      select: this.statusTranslationsService.i18nBouncedSelect,
      class: 'esf-tag--info'
    }
  ];

  constructor(status: string, private statusTranslationsService: CampaignStatusTranslationsService) {
    this.status = status;
  }

  get translatedCampaignStatus(): string {
    const translatedStatus = this.statuses.find((status: Status) => this.status === status.value);
    return translatedStatus ? translatedStatus.status : null;
  }

  get statusCssClass(): any {
    const newStatus = this.statuses.find((status: Status) => this.status === status.value);
    return newStatus ? newStatus.class : null;
  }
}
